export default __webpack_public_path__ + "img/btn-search.54ff7732.svg";